export default "__VITE_ASSET__D0o55Dsl__"